export class BuyerExtrnalRefIdReq{
    extrnalRefId?:string;

    constructor(extrnalRefId?:string){
        this.extrnalRefId = extrnalRefId
    }
}